import { render, staticRenderFns } from "./ButtonSavingLoader.vue?vue&type=template&id=168347f8&scoped=true"
import script from "./ButtonSavingLoader.vue?vue&type=script&lang=js"
export * from "./ButtonSavingLoader.vue?vue&type=script&lang=js"
import style0 from "./ButtonSavingLoader.vue?vue&type=style&index=0&id=168347f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168347f8",
  null
  
)

export default component.exports